<template>
  <!-- modal class is overwritten by bulma, therefore removed -->
  <div class="select-none fixe inset-0 z-modal-overlay overflow-x-hidden overflow-y-auto fixed">
    <div class="relative h-full mx-auto flex items-center justify-center z-modal">
      <div v-on-clickaway="clickaway">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import { mixin as clickaway } from 'vue-clickaway';
  import composedPath from '@/_legacy/polyfills/composedPath';

  function pathIncludesClass(event, className) {
    return composedPath(event)
      .filter(el => el !== document && el !== window)
      .reduce((acc, e) => acc.concat([...e.classList]), [])
      .includes(className);
  }

  export default {
    mixins: [clickaway],

    props: {
      classWhitelist: {
        type: [Array, String],
        default: null,
      },
      clickawayEnabled: {
        type: Boolean,
        default: true,
      },
    },

    data: () => ({ modalBg: null }),

    created() {
      document.addEventListener('keydown', this.handleEscape);
      document.body.classList.add('overflow-hidden');

      const modalBg = document.createElement('div');
      modalBg.classList.add('fixed', 'inset-0', 'bg-80', 'z-30', 'opacity-75');

      this.modalBg = modalBg;

      document.body.appendChild(this.modalBg);
    },

    destroyed() {
      document.removeEventListener('keydown', this.handleEscape);
      document.body.classList.remove('overflow-hidden');
      document.body.removeChild(this.modalBg);
    },

    methods: {
      handleEscape(e) {
        e.stopPropagation();

        if (e.keyCode === 27) {
          this.close(e);
        }
      },

      clickaway(e) {
        if (this.clickawayEnabled) {
          return this.close(e);
        }
        return undefined;
      },

      close(e) {
        const classArray = Array.isArray(this.classWhitelist)
          ? this.classWhitelist
          : [this.classWhitelist];

        if (_.filter(classArray, className => pathIncludesClass(e, className)).length > 0) {
          return;
        }

        this.$emit('modal-close', e);
      },
    },
  };
</script>
